export default __webpack_public_path__ + "static/media/think-markets-logo-stacked.a3d83953.svg";